import Http from '../util/Http'

class SearchApi {
    static async searchShopping(keyword, prodNm) {
        const res = await Http.get(`/search/shopping?keyword=${keyword}&prodNm=${prodNm}`);
        return res || {};
    }

    static async searchPlace(keyword, prodNm) {
        const res = await Http.get(`/search/place?keyword=${keyword}&prodNm=${prodNm}`);
        return res || {};
    }

    static async searchPlaceRepresentKeywords(keyword, prodNm) {
        const res = await Http.get(`/search/representKeywords?prodNm=${prodNm}`);
        return res || {};
    }

    static async searchVisitorCounts(keyword, prodNm) {
        const res = await Http.get(`/search/visitorCounts?prodNm=${prodNm}`);
        return res || {};
    }

    static async searchAmount(keyword, prodNm) {
        const res = await Http.get(`/search/searchAmount?prodNm=${prodNm}`);
        return res || {};
    }

    static async relateKeywords(keyword, prodNm) {
        const res = await Http.get(`/search/relateKeywords?prodNm=${prodNm}`);
        return res || {};
    }


    static async getTmpSlot(slotId) {
        const res = await Http.get(`/slot/tmpSlot/${slotId}?isSelfLoading=true`);
        return res || {};
    }


}

export default SearchApi